import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DownstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
